export default __webpack_public_path__ + "static/22_31-f38bcfd8a6c51ac5a0c95dc58dd710ea.png";